import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import createCanonicalUrl from "../utils/createCanonicalUrl"
import TitleAndMetaTags from "../components/TitleAndMetaTags"
import { withStyles } from "@material-ui/core/styles"

import LandingNews from "../components/LandingNews"

const styles = {
  root: {
    width: "100%",
  },
}

const AllNews = ({ data, location, classes }) => (
  <Layout location={location}>
    <TitleAndMetaTags
      title="News &ndash; DB System NUS"
      canonicalUrl={createCanonicalUrl("/news/")}
    />
    <div className={classes.root}>
      <LandingNews recentNews={data.allMarkdownRemark.edges} showAll={true} />
    </div>
  </Layout>
)

AllNews.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(AllNews)

export const AllNewsQuery = graphql`
  query AllNewsQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
            featuredImage {
              childImageSharp {
                # Other options include height (set both width and height to crop),
                fixed(width: 150) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`
